import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";
import React from "react";
import { SndGradiantDiv } from "../../../../Styles/style";
import SectionsHeading from "../../SectionsHeading";
import Paragraph from "../../Paragraph";
import image1 from "../../../../../assets/Images/books.png";
import image2 from "../../../../../assets/Images/files.png";
import CustomButton from "../../CustomBtn";

const ContinerWraper = styled(Container)`
  position: relative;
  height: auto;
  width: 100%;
  padding: 100px 0 !important;
`;


const DocumentSection = () => {
  return (
    <ContinerWraper maxWidth="xxl" id="document">
      <Container>
        <Grid
          container
          sx={{
            display: "flex",
            justifyContent: "center",
            rowGap: "20px",
            zIndex: "1",
            columnGap:"100px"
          }}
        >
          <Grid item xs={12}>
            <SectionsHeading
              ta="center"
              fs="46px"
              fs599="32px"
              color="#FC9C00 !important"
            >
              Shia Vault Documentation
            </SectionsHeading>
          </Grid>
          <Grid item xs={8} sm={4} md={3}>
            <SndGradiantDiv bg={image1} h="400px">
              <div style={{ display: "flex", alignItems: "center" }}>
                <SectionsHeading
                  ta="left"
                  fs="22px"
                  fs599="22px"
                  color="#FC9C00 !important"
                >
                  Whitepaper
                </SectionsHeading>
              </div>
              <Paragraph ta="left" fs="12px" p="10px 0">
                Know all you need to about Shia Vault in one place.
              </Paragraph>
              <CustomButton
                bgc="transparent"
                c="#fff"
                hbgc="#fff"
                hc="#000"
                b="1px solid #fff"
                fs="12px"
              >
                Coming Soon
              </CustomButton>
            </SndGradiantDiv>
          </Grid>
          <Grid item xs={8} sm={4} md={3}>
            <SndGradiantDiv bg={image2} h="400px">
              <div style={{ display: "flex", alignItems: "center" }}>
                <SectionsHeading
                  ta="left"
                  fs="22px"
                  fs599="22px"
                  color="#FC9C00 !important"
                >
                  Audit
                </SectionsHeading>
              </div>
              <Paragraph ta="left" fs="12px" p="10px 0">
                Worried about our authenticity? Check out our audit report.
              </Paragraph>
              <CustomButton
                bgc="transparent"
                c="#fff"
                hbgc="#fff"
                hc="#000"
                b="1px solid #fff"
                fs="12px"
              >
                Coming Soon
              </CustomButton>
            </SndGradiantDiv>
          </Grid>
        </Grid>
      </Container>
    </ContinerWraper>
  );
};

export default DocumentSection;
